import { render, staticRenderFns } from "./bannerStepper.vue?vue&type=template&id=3b5478d3&scoped=true"
import script from "./bannerStepper.vue?vue&type=script&lang=js"
export * from "./bannerStepper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5478d3",
  null
  
)

export default component.exports